<template>
  <div class="input-text-copy">
    <component
      :is="monospaced ? 'pre' : 'div'"
      class="input-text-copy__text"
      :style="{
        'white-space': inLine ? 'nowrap' : undefined,
      }"
    >
      {{ displayedText }}
    </component>

    <div>
      <SemanticButton
        variant="copy"
        presentation="inline"
        :label="t('copy')"
        @click="copy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import useLibraryI18n from '../../i18n/composable.ts';
import SemanticButton from '../button/semantic-button.vue';

const props = defineProps<{
  copyString: string,
  label?: string,
  inLine?: boolean,
  /**
   * When set to true, a monospaced font will be used to display the text.
   */
  monospaced?: boolean,
}>();

const {
  t,
} = useLibraryI18n('components/text-copy/text-copy');

const displayedText = props.label || props.copyString;

function copy() {
  navigator.clipboard.writeText(props.copyString);
}
</script>

<style scoped lang="scss">
.input-text-copy {
  border: 1px solid var(--border-color-strong);
  border-radius: var(--border-radius);
  display: grid;
  grid-template-columns: 1fr auto;

  &__text {
    padding: var(--gap);
    overflow-x: auto;
    word-break: break-all;
  }
}
</style>
